module.exports = __webpack_public_path__ + "static/media/wonderland.5c88dda6.jpg";